import { formatRupees } from './money.js';

/** The words for a line of a deal's timeline: an i18n key and its values. Never the raw event name. */
export function eventLine(
  type: string,
  payload: Record<string, unknown> | undefined,
): { key: string; values: Record<string, string | number> } {
  const p = payload ?? {};
  const text = (v: unknown): string => (typeof v === 'string' ? v : '');
  const num = (v: unknown): number => (typeof v === 'number' ? v : 0);
  const side = (v: unknown): string =>
    v === 'tenant' ? 'client' : v === 'owner' ? 'owner' : v === 'broker' ? 'broker' : 'someone';
  /** The person by name when the event carries it, else by side. */
  const who = (): string => (text(p['name']) !== '' ? text(p['name']) : `The ${side(p['party'])}`);
  switch (type) {
    case 'memo.sent':
      return { key: 'deals.event_memo_sent', values: { version: num(p['version']) } };
    case 'memo.opened_by':
      return { key: 'deals.event_memo_opened_by', values: { who: who() } };
    case 'memo.signed_by':
      return { key: 'deals.event_memo_signed_by', values: { who: who() } };
    case 'client.phone_changed':
      return { key: 'deals.event_client_phone_changed', values: { last4: text(p['last4']) } };
    case 'brokerage.received':
      return {
        key: 'deals.event_brokerage_received',
        values: { amount: formatRupees(num(p['amountPaise'])), payer: side(p['payer']) },
      };
    case 'status_link.made':
    case 'status_link.opened':
    case 'status_link.revoked':
      return {
        key: `deals.event_${type.replace(/\./g, '_')}`,
        values: { side: side(p['party']) },
      };
    case 'deal.created':
    case 'deal.reassigned':
    case 'terms.updated':
    case 'memo.fully_signed':
    case 'agreement.saved':
    case 'partner.job_sent':
    case 'partner.visit_booked':
    case 'partner.completed':
    case 'token.claimed':
    case 'token.claim_changed':
    case 'token.confirmed':
    case 'token.not_received':
    case 'token.reopened':
    case 'state.token_recorded':
    case 'state.memo_signed':
    case 'state.agreement_drafted':
    case 'state.registered':
    case 'state.closed':
    case 'state.lost':
    case 'state.cancelled':
      return { key: `deals.event_${type.replace(/\./g, '_')}`, values: {} };
    default:
      return { key: 'deals.event_other', values: {} };
  }
}
